import qs from 'querystring';
import has from 'lodash/has';
import debug from 'debug';

if (process.env.NODE_ENV !== 'production') {
  debug.enable('app:*');
}

if (process.env.NODE_ENV === 'production') {
  const query = qs.parse(window.location.search.replace(/^\?/, ''));
  if (has(query, 'log')) {
    debug.enable('app:*');
  } else {
    debug.disable();
  }
}

export default class Debug {
  constructor(label) {
    return debug(`app:${label}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/Debug/Debug.js